import {
  ConfirmDialogProvider as BaseConfirmDialogProvider,
  ConfirmOptions,
} from '@omit/react-confirm-dialog';

interface Props {
  children: React.ReactNode;
  defaultOptions?: ConfirmOptions;
}

const sedeDefaultOptions: ConfirmOptions = {
  alertDialogOverlay: {
    className: 'z-toast', // Higher than Dialog system (base 40 + increments)
  },
  alertDialogContent: {
    className: 'py-[60px] px-[74px] rounded-[5px] max-w-[571px] z-toast',
  },
  // icon: <ChevronDown />,
  alertDialogHeader: {
    className: 'flex items-center justify-center',
  },
  alertDialogTitle: {
    className:
      'text-center text-2xl font-semibold leading-9 text-primaryDark flex items-center flex-col justify-center',
  },
  alertDialogDescription: {
    className: 'text-center text-base font-medium leading-6 text-tundora',
  },
  cancelButton: {
    className:
      'text-center text-[#D31F3F] text-sm font-medium leading-6 border-2 border-[#D31F3F] bg-white rounded-[24px] p-[9px] hover:text-white hover:bg-[#D31F3F]',
  },
  confirmButton: {
    className:
      'text-center bg-marine text-white text-sm font-medium leading-6 border-2 border-marine rounded-[24px] p-[9px] hover:text-white hover:bg-marine',
  },
  alertDialogFooter: {
    className: 'flex items-center justify-between max-w-[423px]',
  },
};

export const ConfirmDialogProvider = ({ children, defaultOptions }: Props) => {
  return (
    <BaseConfirmDialogProvider defaultOptions={{ ...sedeDefaultOptions, ...defaultOptions }}>
      {/* <div className="text-center  text-base font-medium leading-6 text-tundora" /> */}
      {/* <div className='text-2xl font-semibold leading-9 text-primaryDark' /> */}
      {children}
    </BaseConfirmDialogProvider>
  );
};
